import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { Mg68 } from './mg68'
import { KK } from '@/define/define'

export class Mg68ACE_UpPlus extends Mg68 {
  name: string = 'MG68_Plus'
  icon: string = list_icon
  width: number = 710
  fnDisableKeys: KK[] = [0x1, 0x8, 0xe, 0x14, 0x1a, 0x3d, 0x43, 0x49, 0x4f, 0x55, 0x57, 0x58, 0x59, 0x53, 0x4d, 0x52, 0x41, 0xb, 0x10, 0x16, 0x1c, 0x22, 0x44, 0x4a]
}
